import React, { useState, useEffect } from "react";
import Alert from "@mui/material/Alert";
import { Form, Button, Container, Row, Col } from "react-bootstrap";
import { countryOptions } from "../Constants";
import OrganizationDetails from "./OrganizationDetails";
import DocumentUpload from "./DocumentUpload";
import "./PersonalInformation.css";
import { useTranslation } from "react-i18next";
import { submitPersonalInformation } from "../services/personalInformationService";
import PhoneInput from "react-phone-input-2";
import DatePicker from "react-datepicker";
import { az, enUS } from "date-fns/locale";
import { format } from "date-fns";
import "react-phone-input-2/lib/style.css";
import "react-datepicker/dist/react-datepicker.css";

const PersonalInformation = ({
  onNext,
  email,
  language,
  token,
  nationality,
  activeLang
}) => {
  const { t, i18n } = useTranslation();
  const [errorMessage, setErrorMessage] = useState("");
  const [errors, setErrors] = useState({});
  const [form, setForm] = useState({
    // title: "",
    firstName: "",
    lastName: "",
    fatherName: "",
    mediaType: "",
    mediaTypeDescription: "",
    gender: "",
    dateOfBirth: "",
    placeOfBirth: "",
    nationality: nationality,
    residenceCountry: "",
    residenceCity: "",
    idNumber: "",
    finCode: "",
    address: "",
    mobile: "",
    email: email,
    participation: "",
    experience: "",
    disability: "",
    disabilityDescription: "",
    comments: "",
    organizationType: {},
    organization: {},
    formalApplicationLetter: null,
    passportSizePhoto: null,
    pressCardScan: null,
    idScan: null,
    agreeToShareInfo: false,
    confirmAccuracy: false,
    language: language,
  });


  const getLocale = () => {
    return activeLang === "az" ? az : enUS;
  };

  const [currentStep, setCurrentStep] = useState(1);
  const showError = (message) => {
    setErrorMessage(message);
    setTimeout(() => {
      setErrorMessage("");
    }, 10000); // Hide after 10 seconds
  };
  const sortedCountryOptions = countryOptions.sort((a, b) => {
    const countryA = t(a.value).toLowerCase(); // Get translated country name
    const countryB = t(b.value).toLowerCase();
    return countryA.localeCompare(countryB, i18n.language); // Sort based on current language
  });
  useEffect(() => {
    showError("");
  }, []);
  const validatePersonalInfo = () => {
    const newErrors = {};
    if (!form.firstName || form.firstName === "")
      newErrors.firstName = t("validation.firstName");
    if (!form.lastName || form.lastName === "")
      newErrors.lastName = t("validation.lastName");
    if (
      form.nationality === "AZE" &&
      (!form.fatherName || form.fatherName === "")
    )
      newErrors.fatherName = t("validation.fatherName");
    if (!form.gender || form.gender === "")
      newErrors.gender = t("validation.gender");
    let formattedDateOfBirth = "";
    if (form.dateOfBirth) {
      formattedDateOfBirth = format(new Date(form.dateOfBirth), "yyyy-MM-dd");
    }

    const dateOfBirthRegex = /^\d{4}-\d{2}-\d{2}$/;
    if (!formattedDateOfBirth || formattedDateOfBirth === "") {
      newErrors.dateOfBirth = t("validation.dateOfBirth");
    } else if (!dateOfBirthRegex.test(formattedDateOfBirth)) {
      newErrors.dateOfBirth = t("validation.invalidDateFormat");
    }
    if (!form.placeOfBirth || form.placeOfBirth === "")
      newErrors.placeOfBirth = t("validation.placeOfBirth");
    if (!form.nationality || form.nationality === "")
      newErrors.nationality = t("validation.nationality");
    if (!form.residenceCountry || form.residenceCountry === "")
      newErrors.residenceCountry = t("validation.residenceCountry");
    if (!form.residenceCity || form.residenceCity === "")
      newErrors.residenceCity = t("validation.residenceCity");
    if (!form.idNumber || form.idNumber === "")
      newErrors.idNumber = t("validation.idNumber");
    if (!form.finCode && form.nationality === "AZE")
      newErrors.finCode = t("validation.finCode");
    if (!form.address || form.address === "")
      newErrors.address = t("validation.address");
    // if (!form.mobile || form.mobile === "") newErrors.mobile = t("validation.mobile");
    if (!form.email || form.email === "")
      newErrors.email = t("validation.email");

    if (form.mobile.length < 9) {
      newErrors.mobile = t("validation.mobile");
    }

    if (!form.participation || form.participation === "")
      newErrors.participation = t("validation.participation");
    if (
      form.participation === "true" &&
      (!form.experience || form.experience === "")
    )
      newErrors.experience = t("validation.describeExperience");

    if (!form.disability || form.disability === "")
      newErrors.disability = t("validation.disability");
    if (
      form.disability === "true" &&
      (!form.disabilityDescription || form.disabilityDescription === "")
    )
      newErrors.disabilityDescription = t("validation.disabilityDescription");

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const validateOrganizationDetails = () => {
    const newErrors = {};

    if (
      !form.organization.organization ||
      form.organization.organization === ""
    ) {
      newErrors.organization = t("validation.organization");
    }
    if (!form.organization.department || form.organization.department === "") {
      newErrors.organizationDepartment = t("validation.depatment");
    }
    if (!form.organization.jobTitle || form.organization.jobTitle === "") {
      newErrors.jobTitle = t("validation.jobTitle");
    }
    if (!form.organization.address || form.organization.address === "") {
      newErrors.organizationAddress = t("validation.address");
    }
    if (!form.organization.city || form.organization.city === "") {
      newErrors.organizationCity = t("validation.city");
    }
    if (!form.organization.postalCode || form.organization.postalCode === "") {
      newErrors.organizationPostalCode = t("validation.postalCode");
    }

    if (!form.organization.phone1 || form.organization.phone1 < 9) {
      newErrors.phone1 = t("validation.phone1");
    }
    // if (!form.organization.phone1 || form.organization.phone1 === "") {
    //   newErrors.phone1 = t("validation.phone1");
    // }

    if (
      !form.organization.email ||
      form.organization.email === "" ||
      !/^[\w.-]+@([\w.-]+\.)+\w{2,4}$/.test(form.organization.email)
    ) {
      newErrors.organizationEmail = t("validation.email");
    }
    if (
      !form.organization.mediaEquipment ||
      form.organization.mediaEquipment === ""
    ) {
      newErrors.organizationMediaEquipment = t("validation.mediaEquipment");
    }

    if (form.mediaType === "WEBSITE") {
      if (
        !form.organizationType.address ||
        form.organizationType.address === ""
      ) {
        newErrors.websiteAddress = t("validation.address");
      }
      if (
        !form.organizationType.visitors ||
        form.organizationType.visitors === ""
      ) {
        newErrors.webVisitors = t("validation.visitors");
      }
      if (!form.organizationType.COP29 || form.organizationType.COP29 === "") {
        newErrors.COP29 = t("validation.COP29");
      }
      if (
        form.organizationType.COP29 === "true" &&
        (!form.organizationType.url || form.organizationType.url === "")
      ) {
        newErrors.url = t("validation.copUrl");
      }
    }

    if (
      form.mediaType !== "WEBSITE" &&
      form.mediaType !== "TV" &&
      form.mediaType !== "RADIO"
    ) {
      if (!form.organizationType.name || form.organizationType.name === "") {
        newErrors.publicationName = t("validation.publicationName");
      }
      if (
        !form.organizationType.frequency ||
        form.organizationType.frequency === ""
      ) {
        newErrors.frequency = t("validation.frequency");
      }
      if (
        form.organizationType.frequency === "OTHER" &&
        (!form.organizationType.otherFrequency ||
          form.organizationType.otherFrequency === "")
      ) {
        newErrors.otherFrequency = t("validation.otherFrequency");
      }
      if (
        !form.organizationType.circulationVisitors ||
        form.organizationType.circulationVisitors === ""
      ) {
        newErrors.circulation = t("validation.circulation");
      }
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const validateDocumentUpload = () => {
    const newErrors = {};

    if (!form.idScan || form.idScan === "") newErrors.idScan = "idscan";
    if (!form.formalApplicationLetter || form.formalApplicationLetter === "")
      newErrors.formalApplicationLetter = "formalApplicationLetter";
    if (!form.passportSizePhoto || form.passportSizePhoto === "")
      newErrors.passportSizePhoto = "passportSizePhoto";
    if (!form.pressCardScan || form.pressCardScan === "")
      newErrors.pressCardScan = "pressCardScan";

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };



  const handleSmallChange = (e) => {
    const { name, value } = e.target;
    const [parent, child] = name.split(".");
  
    const regex = /^(?![=+\-@])[\s\S]{0,20}$/;
    const isValid = value === "" || regex.test(value);
  console.log(`Value: "${value}", Is Valid: ${isValid}`);
  const updatedValue = value === "" ? null : value;
  if (isValid) {
    if (child) {
      setForm((prevForm) => ({
        ...prevForm,
        [parent]: {
          ...prevForm[parent],
          [child]: updatedValue,
        },
      }));
    } else {
      setForm({ ...form, [name]: updatedValue });
    }
  }
  };

  const handleLetterChange = (e) => {
    const { name, value } = e.target;
    const [parent, child] = name.split(".");

    const regex = /^(?![=+\-@])[\s\S]{0,50}$/;
    const isValid = regex.test(value);

    const updatedValue = value === "null" || value === "" ? null : value;
    if (isValid) {
      if (child) {
        setForm((prevForm) => ({
          ...prevForm,
          [parent]: {
            ...prevForm[parent],
            [child]: updatedValue,
          },
        }));
      } else {
        setForm({ ...form, [name]: updatedValue });
      }
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    const [parent, child] = name.split(".");
    const regex = /^(?![=+\-@])[\s\S]{0,100}$/;
    const isValid = regex.test(value);

    const updatedValue = value === "null" || value === "" ? null : value;
    if (isValid) {
      if (child) {
        setForm((prevForm) => ({
          ...prevForm,
          [parent]: {
            ...prevForm[parent],
            [child]: updatedValue,
          },
        }));
      } else {
        setForm({ ...form, [name]: updatedValue });
      }
    }
  };

  const handleDateChange = (date) => {
    setForm({ ...form, dateOfBirth: date });
  };

  const handleEnumChange = (e) => {
    const { name, value } = e.target;
    const updatedValue = value === "null" || value === "" ? null : value;
    setForm({ ...form, [name]: updatedValue });
  };

  const handleNumberChange = (e) => {
    const { name, value } = e.target;
    const [parent, child] = name.split(".");

    const number = e.target.value;
    if (/^\d{0,15}$/.test(number)) {
      if (child) {
        setForm((prevForm) => ({
          ...prevForm,
          [parent]: {
            ...prevForm[parent],
            [child]: value,
          },
        }));
      } else {
        setForm({ ...form, [name]: value });
      }
    }
  };
  const handleEmailChange = (e) => {
    const { name, value } = e.target;
    const [parent, child] = name.split(".");

    
    if (child) {
      setForm((prevForm) => ({
        ...prevForm,
        [parent]: {
          ...prevForm[parent],
          [child]: value,
        },
      }));
    } else {
      setForm((prevForm) => ({
        ...prevForm,
        [name]: value,
      }));
    }

 
    const email = value;
    const regex = /^[\w.-]+@([\w.-]+\.)+\w{2,4}$/;

    if (!regex.test(email) && email !== "") {
      console.log("email"); 
    }
  };

  const handlePhoneNumberChange = (fieldPath, phone) => {
    const fields = fieldPath.split(".");

    if (fields.length === 1) {
      setForm({ ...form, [fields[0]]: phone });
    } else if (fields.length === 2) {
      setForm((prevForm) => ({
        ...prevForm,
        [fields[0]]: {
          ...prevForm[fields[0]],
          [fields[1]]: phone,
        },
      }));
    }

    // setErrors({ ...errors, [fields[0]]: null });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (validateDocumentUpload()) {
      const formData = new FormData();
      const requestObject = {
        mediaType: form.mediaType,
        // title: form.title,
        name: form.firstName,
        surname: form.lastName,
        fathersName: form.fatherName,
        gender: form.gender,
        dateOfBirth: format(form.dateOfBirth, "yyyy-MM-dd"),
        placeOfBirth: form.placeOfBirth,
        nationality: form.nationality,
        residenceCountry: form.residenceCountry,
        residenceCity: form.residenceCity,
        nationalIdNumber: form.idNumber,
        finCode: form.finCode,
        address: form.address,
        mobile: form.mobile,
        email: form.email,
        earlierParticipation: form.participation === "true", // Convert to boolean
        earlierParticipationDescription: form.experience || "",
        disability: form.disability === "true", // Convert to boolean
        disabilityDescription: form.disabilityDescription || "",
        comments: form.comments || "",
        language: form.language,
        mediaTypeDescription: form.mediaTypeDescription,
      };
      requestObject.organization = {
        ...form.organization,
        mediaEquipment: form.organization.mediaEquipment === "true",
      };

      if (requestObject.mediaType === "WEBSITE") {
        requestObject.website = {
          ...form.organizationType,
          COP29: form.organizationType.COP29 === "true",
        };
      } else if (
        requestObject.mediaType !== "WEBSITE" &&
        requestObject.mediaType !== "TV" &&
        requestObject.mediaType !== "RADIO"
      ) {
        requestObject.publication = form.organizationType;
      }

      console.log(requestObject);
      formData.append(
        "request",
        new Blob([JSON.stringify(requestObject)], {
          type: "application/json",
        })
      );
      formData.append("idScan", form.idScan);
      formData.append("formalApplicationLetter", form.formalApplicationLetter);
      formData.append("passportSizePhoto", form.passportSizePhoto);
      formData.append("pressCardScan", form.pressCardScan);
      formData.append("registerCertificate", form.registerCertificate);

      try {
        console.log(token);
        await submitPersonalInformation(formData, token);
        onNext();
      } catch (error) {
        console.log(error);
        if (error.response?.status === 409) {
          showError("Application with this email already exists");
          return;
        }
        if (error.response?.status === 400) {
          console.error("Form submission error:", error);
          showError("Form submission error");

          return;
        }
      }
    }
  };

  const handleNext = () => {
    console.log(form);
    console.log(errors);

    if (currentStep === 1) {
      // Validate personal information before moving to next step
      if (validatePersonalInfo()) {
        setCurrentStep(currentStep + 1);
      }
    } else if (currentStep === 2) {
      // Validate organization details before moving to next step
      if (validateOrganizationDetails()) {
        setCurrentStep(currentStep + 1);
      }
    }
  };

  const handleBack = () => {
    setCurrentStep(currentStep - 1);
  };
  return (
    <Container style={{ paddingBottom: "2rem" }}>
      {errorMessage && (
        <Alert
          severity="error"
          sx={{
            position: "fixed",
            bottom: 0,
            left: 0,
            margin: 6,
          }}
        >
          {errorMessage}
        </Alert>
      )}
      <Row className="justify-content-center mt-5">
        <Col md={8}>
          <Form>
            {currentStep === 1 && (
              <>
                <h3 className="border-h3">
                  {t("personalInformation.personalInfo")}
                </h3>

                <p className="mark-message">{t("header.mandatory")}</p>
                <Form.Group controlId="formFirstName" className="mt-3">
                  <Form.Label>
                    {t("personalInformation.firstName")} *
                  </Form.Label>
                  <Form.Control
                    type="text"
                    name="firstName"
                    value={form.firstName}
                    onChange={handleSmallChange}
                    isInvalid={!!errors.firstName}
                    required
                  />
                  <Form.Control.Feedback type="invalid">
                    {t("validation.field")}
                  </Form.Control.Feedback>
                </Form.Group>
                <Form.Group controlId="formLastName" className="mt-3">
                  <Form.Label>{t("personalInformation.lastName")} *</Form.Label>
                  <Form.Control
                    type="text"
                    name="lastName"
                    value={form.lastName}
                    onChange={handleSmallChange}
                    isInvalid={!!errors.lastName}
                    required
                  />
                  <Form.Control.Feedback type="invalid">
                    {t("validation.field")}
                  </Form.Control.Feedback>
                </Form.Group>
                <Form.Group controlId="formFatherName" className="mt-3">
                  <Form.Label>
                    {t("personalInformation.fatherName")}{" "}
                    {form.nationality === "AZE" && " *"}
                  </Form.Label>
                  <Form.Control
                    type="text"
                    name="fatherName"
                    value={form.fatherName}
                    onChange={handleSmallChange}
                    isInvalid={!!errors.fatherName}
                    maxLength={20}
                    required
                  />
                  <Form.Control.Feedback type="invalid">
                    {t("validation.field")}
                  </Form.Control.Feedback>
                </Form.Group>

                <Form.Group controlId="formGender" className="mt-3">
                  <Form.Label>{t("personalInformation.gender")} *</Form.Label>
                  <Form.Control className="form-select"
                    as="select"
                    name="gender"
                    value={form.gender}
                    onChange={handleEnumChange}
                    isInvalid={!!errors.gender}
                    required
                  >
                    <option value="">{t("choose")}</option>
                    <option value="MALE">
                      {t("personalInformation.genderOptions.MALE")}
                    </option>
                    <option value="FEMALE">
                      {t("personalInformation.genderOptions.FEMALE")}
                    </option>
                    <option value="PREFER_NOT_TO_SAY">
                      {t("personalInformation.genderOptions.PREFER_NOT_TO_SAY")}
                    </option>
                  </Form.Control>
                  <Form.Control.Feedback type="invalid">
                    {t("validation.field")}
                  </Form.Control.Feedback>
                </Form.Group>
                <Form.Group controlId="formDateOfBirth" className="mt-3">
                  <Form.Label>{t("personalInformation.dateOfBirth")}  *</Form.Label>
                  <br></br>
                  <DatePicker
                    selected={
                      form.dateOfBirth ? new Date(form.dateOfBirth) : null
                    }
                    maxDate={new Date()}
                    minDate={new Date("1900-01-01")}
                    showYearDropdown
                    showMonthDropdown
                    yearDropdownItemNumber={123}
                    locale={getLocale()}
                    scrollableYearDropdown
                    onChange={handleDateChange} // Use the new method here
                    dateFormat="dd/MM/yyyy"
                    placeholderText={t("personalInformation.datePicker")}
                    className={`form-control ${errors.dateOfBirth ? "is-invalid" : ""
                      }`}
                    required
                  />
                  <Form.Control.Feedback type="invalid">
                    {t("validation.field")}
                  </Form.Control.Feedback>
                </Form.Group>
                <Form.Group controlId="formPlaceOfBirth" className="mt-3">
                  <Form.Label>
                    {t("personalInformation.placeOfBirth")} *
                  </Form.Label>
                  <Form.Control
                    type="text"
                    name="placeOfBirth"
                    value={form.placeOfBirth}
                    onChange={handleLetterChange}
                    isInvalid={!!errors.placeOfBirth}
                    required
                  />
                  <Form.Control.Feedback type="invalid">
                    {t("validation.field")}
                  </Form.Control.Feedback>
                </Form.Group>
                <Form.Group controlId="formNationality" className="mt-3">
                  <Form.Label>
                    {t("personalInformation.nationality")} *
                  </Form.Label>
                  <Form.Control className="form-select"
                    as="select"
                    name="nationality"
                    value={form.nationality}
                    onChange={handleLetterChange}
                    isInvalid={!!errors.nationality}
                    required
                  >
                    <option value="">{t("choose")}</option>
                    {sortedCountryOptions.map((country, index) => (
                      <option key={index} value={country.name}>
                        {t(country.value)}
                      </option>
                    ))}
                  </Form.Control>
                  <Form.Control.Feedback type="invalid">
                    {t("validation.field")}
                  </Form.Control.Feedback>
                </Form.Group>
                <Form.Group controlId="formResidenceCountry" className="mt-3">
                  <Form.Label>
                    {t("personalInformation.residenceCountry")} *
                  </Form.Label>
                  <Form.Control className="form-select"
                    as="select"
                    name="residenceCountry"
                    value={form.residenceCountry}
                    onChange={handleLetterChange}
                    isInvalid={!!errors.residenceCountry}
                    required
                  >
                    <option value="">{t("choose")}</option>
                    {sortedCountryOptions.map((country, index) => (
                      <option key={index} value={country.name}>
                        {t(country.value)}
                      </option>
                    ))}
                  </Form.Control>
                  <Form.Control.Feedback type="invalid">
                    {t("validation.field")}
                  </Form.Control.Feedback>
                </Form.Group>
                <Form.Group controlId="formResidenceCity" className="mt-3">
                  <Form.Label>
                    {t("personalInformation.residenceCity")} *
                  </Form.Label>
                  <Form.Control
                    type="text"
                    name="residenceCity"
                    value={form.residenceCity}
                    isInvalid={!!errors.residenceCity}
                    onChange={handleLetterChange}
                    required
                  />
                  <Form.Control.Feedback type="invalid">
                    {t("validation.field")}
                  </Form.Control.Feedback>
                </Form.Group>
                <Form.Group controlId="formIdNumber" className="mt-3">
                  <Form.Label>{t("personalInformation.idNumber")} *</Form.Label>
                  <Form.Control
                    type="text"
                    name="idNumber"
                    value={form.idNumber}
                    isInvalid={!!errors.idNumber}
                    onChange={handleSmallChange}
                    required
                  />
                  <Form.Control.Feedback type="invalid">
                    {t("validation.field")}
                  </Form.Control.Feedback>
                </Form.Group>
                {form.nationality === "AZE" && (
                  <Form.Group controlId="formFinCode" className="mt-3">
                    <Form.Label>
                      {t("personalInformation.finCode")} *
                    </Form.Label>
                    <Form.Control
                      type="text"
                      name="finCode"
                      value={form.finCode}
                      isInvalid={!!errors.finCode}
                      onChange={handleSmallChange}
                      required
                    />
                    <Form.Control.Feedback type="invalid">
                      {t("validation.field")}
                    </Form.Control.Feedback>
                  </Form.Group>
                )}

                <Form.Group controlId="formAddress" className="mt-3">
                  <Form.Label>{t("personalInformation.address")} *</Form.Label>
                  <Form.Control
                    type="text"
                    name="address"
                    isInvalid={!!errors.address}
                    value={form.address}
                    onChange={handleLetterChange}
                    required
                  />
                  <Form.Control.Feedback type="invalid">
                    {t("validation.field")}
                  </Form.Control.Feedback>
                </Form.Group>
                <Form.Group controlId="formMobile" className="mt-3">
                  <Form.Label>{t("personalInformation.mobile")} *</Form.Label>
                  <div
                    className={`input-group ${!!errors.mobile ? "is-invalid-custom" : ""
                      }`}
                  >
                    <PhoneInput
                      country={"az"}
                      value={form.mobile}
                      onChange={(phone) =>
                        handlePhoneNumberChange("mobile", phone)
                      }
                      inputProps={{
                        name: "mobile",
                        required: true,
                      }}
                    />
                    {!!errors.mobile && (
                      <div className="invalid-feedback-custom ">
                        {t("validation.field")}
                      </div>
                    )}
                  </div>
                </Form.Group>
                <Form.Group controlId="formEmail" className="mt-3">
                  <Form.Label>{t("personalInformation.email")} *</Form.Label>
                  <Form.Control
                    type="email"
                    name="email"
                    value={email}
                    onChange={handleEmailChange}
                    disabled
                  />
                </Form.Group>
                <Form.Group controlId="formParticipation" className="mt-3">
                  <Form.Label>
                    {t("personalInformation.participation")} *
                  </Form.Label>
                  <Form.Control className="form-select"
                    as="select"
                    name="participation"
                    value={form.participation}
                    onChange={handleLetterChange}
                    isInvalid={!!errors.participation}
                    required
                  >
                    <option value="">{t("choose")}</option>
                    <option value={true}>{t("yes")}</option>
                    <option value={false}>{t("no")}</option>
                  </Form.Control>
                  <Form.Control.Feedback type="invalid">
                    {t("validation.field")}
                  </Form.Control.Feedback>
                </Form.Group>
                {form.participation === "true" && (
                  <Form.Group controlId="formExperience" className="mt-3">
                    <Form.Label>
                      {t("personalInformation.experience")} *
                    </Form.Label>
                    <Form.Control
                      type="text"
                      name="experience"
                      value={form.experience}
                      onChange={handleChange}
                      isInvalid={!!errors.experience}
                      required
                    />
                    <Form.Control.Feedback type="invalid">
                      {t("validation.field")}
                    </Form.Control.Feedback>
                  </Form.Group>
                )}
                <Form.Group controlId="formDisability" className="mt-3">
                  <Form.Label>
                    {t("personalInformation.disability")} *
                  </Form.Label>
                  <Form.Control className="form-select"
                    as="select"
                    name="disability"
                    value={form.disability}
                    isInvalid={!!errors.disability}
                    onChange={handleLetterChange}
                    required
                  >
                    <option value="">{t("choose")}</option>
                    <option value={true}>{t("yes")}</option>
                    <option value={false}>{t("no")}</option>
                  </Form.Control>
                  <Form.Control.Feedback type="invalid">
                    {t("validation.field")}
                  </Form.Control.Feedback>
                </Form.Group>
                {form.disability === "true" && (
                  <Form.Group
                    controlId="formDisabilityDescription"
                    className="mt-3"
                  >
                    <Form.Label>
                      {t("personalInformation.disabilityDescription")} *
                    </Form.Label>
                    <Form.Control
                      type="text"
                      name="disabilityDescription"
                      value={form.disabilityDescription}
                      onChange={handleChange}
                      isInvalid={!!errors.disabilityDescription}
                      required
                    />
                    <Form.Control.Feedback type="invalid">
                      {t("validation.field")}
                    </Form.Control.Feedback>
                  </Form.Group>
                )}
                <Form.Group controlId="formComments" className="mt-3">
                  <Form.Label>{t("personalInformation.comments")}</Form.Label>
                  <Form.Control
                    type="text"
                    name="comments"
                    value={form.comments}
                    onChange={handleChange}
                  />
                </Form.Group>
                <Button variant="primary" onClick={handleNext} className="mt-3">
                  {t("next")}
                </Button>
              </>
            )}

            {currentStep === 2 && (
              <>
                <OrganizationDetails
                  form={form}
                  handleNullableChange={handleChange}
                  handleChange={handleChange}
                  handleNumberChange={handleNumberChange}
                  handlePhoneNumberChange={handlePhoneNumberChange}
                  handleEmailChange={handleEmailChange}
                  handleLetterChange={handleLetterChange}
                  handleEnumChange={handleEnumChange}
                  errors={errors}
                />
                <Button
                  variant="secondary"
                  onClick={handleBack}
                  className="mt-3 btn-yellow"
                >
                  {t("back")}
                </Button>
                <Button
                  variant="primary"
                  onClick={handleNext}
                  className="mt-3 ms-2"
                >
                  {t("next")}
                </Button>
              </>
            )}
            {currentStep === 3 && (
              <>
                <DocumentUpload
                  form={form}
                  handleSubmit={handleSubmit}
                  errors={errors}
                  setForm={setForm}
                  handleBack={handleBack}
                />
              </>
            )}
          </Form>
        </Col>
      </Row>
    </Container>
  );
};

export default PersonalInformation;
